import { render, staticRenderFns } from "./cxandcz.vue?vue&type=template&id=04705048&scoped=true"
import script from "./cxandcz.vue?vue&type=script&lang=js"
export * from "./cxandcz.vue?vue&type=script&lang=js"
import style0 from "./cxandcz.vue?vue&type=style&index=0&id=04705048&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04705048",
  null
  
)

export default component.exports